import { Link } from "react-router";

import { formatDateAt } from "simplydo/core/dates";
import { ideaCoverImage } from "simplydo/core/images";

import { useAppSelector } from "store";

import { UserChip } from "components/lib/Chips";

import { FeedItemOfType } from "../types";
import {
  FeedItem,
  FeedItemContent,
  FeedItemDate,
  FeedItemIcon,
  FeedItemMessage,
} from "./FeedItemUI";

type IdeaFeedItemProps = { item: FeedItemOfType<"idea"> };

const IdeaFeedItem = ({ item }: IdeaFeedItemProps) => {
  const currentUser = useAppSelector((state) => state.user);
  const isAuthor = item.user === currentUser?._id;

  return (
    <FeedItem>
      <FeedItemIcon src={ideaCoverImage(item)} />
      <FeedItemContent>
        <FeedItemMessage>
          <b>
            <UserChip user={item.owner} compact="very" />
          </b>{" "}
          <span>
            {isAuthor ? "created" : "added you as a collaborator to"}{" "}
            <Link to={`/ideas/${item._id}`}>{item.name}</Link>.
          </span>
        </FeedItemMessage>
        <FeedItemDate>{formatDateAt(item.createdAt)}</FeedItemDate>
      </FeedItemContent>
    </FeedItem>
  );
};

export default IdeaFeedItem;
